var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loading',{attrs:{"active":_vm.loading,"can-cancel":false,"is-full-page":false},on:{"update:active":function($event){_vm.loading=$event}}},[_vm._v("Sign In Silent")])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/views/Silent.Vue?vue&type=template&id=6d8be9e7
// module id = 231
// module chunks = 0